import { Link } from "gatsby";
import { useEffect } from "react";
import { Category, Subcategory } from "../../../interfaces/Article.interface";
import "./SectionList.scss";

interface Props {
  category: Category;
  selectedSubcategory: Subcategory;
}

const SectionList = ({ category, selectedSubcategory }: Props) => {
  useEffect(() => {
    if (localStorage.getItem("clicked-section")) {
      const idSection = localStorage.getItem("clicked-section")!;
      document.getElementById(idSection)?.scrollIntoView({ block: "center" });
      localStorage.removeItem("clicked-section");
    }
  }, []);

  return (
    <div className="m-section-list">
      <div className="m-section-list__title-box">
        <h1>{selectedSubcategory?.name ?? category?.name}</h1>
        <p>{selectedSubcategory?.desc ?? category?.desc}</p>
      </div>

      {selectedSubcategory ? (
        <div className="m-section-list__item">
          <div className="section-late-articles">
            {selectedSubcategory?.articles?.map(article => (
              <h3
                key={article.url}
                className={`gtmMenulateralsubcategoriasarticulos${article.name.replace(
                  / /g,
                  ""
                )}`}
              >
                <div className="article-bullet" />
                <Link
                  to={article.url}
                  className={`gtmMenulateralsubcategoriasarticulos${article.name.replace(
                    / /g,
                    ""
                  )}`}
                >
                  {article.name}
                </Link>
              </h3>
            ))}
          </div>
        </div>
      ) : (
        <div className="m-section-list__item">
          <div className="section-late-articles">
            {category?.sections?.map(section => (
              <h3
                key={section.url}
                className={`gtmMenulateralsubcategoriasarticulos${section.name.replace(
                  / /g,
                  ""
                )}`}
              >
                <div className="article-bullet" />
                <Link
                  to={section.url}
                  className={`gtmMenulateralsubcategoriasarticulos${section.name.replace(
                    / /g,
                    ""
                  )}`}
                >
                  {section.name}
                </Link>
              </h3>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SectionList;
